import cx from 'classnames'
import { Search } from 'components/lib/icons'
import React from 'react'

import './style.css'

const SearchLabel = ({
  ariaLabel = '',
  ariaLabelledBy = '',
  className = '',
  htmlFor = ''
}) => {
  return (
    <label
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      className={cx('drift-widget--search-label', { [className]: !!className })}
      htmlFor={htmlFor}
      id="driftWidgetSearchLabel"
    >
      <Search titleId={ariaLabelledBy} title={ariaLabel} width={12} height={12} />
    </label>
  )
}

export default SearchLabel
